// frontend/src/components/Governanca/Governanca.tsx

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PublicNav } from '../layout/PublicNav/PublicNav';
import './Governanca.css';

// ============================================================
// ILUSTRAÇÕES SVG (mantidas)
// ============================================================

const AuditLayers: React.FC = () => (
  <svg viewBox="0 0 400 300" className="gov-illustration" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <radialGradient id="auditOuter" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#66bb6a" stopOpacity="0.1" />
        <stop offset="100%" stopColor="#2e7d32" stopOpacity="0.3" />
      </radialGradient>
      <radialGradient id="auditMid" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#ab47bc" stopOpacity="0.15" />
        <stop offset="100%" stopColor="#6a1b9a" stopOpacity="0.35" />
      </radialGradient>
      <radialGradient id="auditInner" cx="50%" cy="50%" r="50%">
        <stop offset="0%" stopColor="#4fc3f7" stopOpacity="0.3" />
        <stop offset="100%" stopColor="#1565c0" stopOpacity="0.5" />
      </radialGradient>
    </defs>

    <circle cx="200" cy="150" r="130" fill="url(#auditOuter)" stroke="#66bb6a" strokeWidth="2" strokeDasharray="6 4" />
    <text x="200" y="40" textAnchor="middle" fill="#66bb6a" fontSize="14" fontWeight="700">AUDITORIA</text>

    <circle cx="200" cy="150" r="90" fill="url(#auditMid)" stroke="#ab47bc" strokeWidth="2" />
    <text x="200" y="80" textAnchor="middle" fill="#ab47bc" fontSize="13" fontWeight="600">EXPLICAÇÃO</text>

    <circle cx="200" cy="150" r="50" fill="url(#auditInner)" stroke="#4fc3f7" strokeWidth="2" />
    <text x="200" y="155" textAnchor="middle" fill="#ffffff" fontSize="13" fontWeight="700">RESULTADO</text>

    {[
      [70, 90], [330, 90], [70, 210], [330, 210],
      [140, 40], [260, 40], [140, 260], [260, 260],
    ].map(([x, y], i) => (
      <circle key={i} cx={x} cy={y} r="4" fill="#4fc3f7" opacity="0.7" />
    ))}
  </svg>
);

const ThreePillars: React.FC = () => (
  <svg viewBox="0 0 500 300" className="gov-illustration" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="pillarReg" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#ef5350" />
        <stop offset="100%" stopColor="#b71c1c" />
      </linearGradient>
      <linearGradient id="pillarBiz" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#ffa726" />
        <stop offset="100%" stopColor="#e65100" />
      </linearGradient>
      <linearGradient id="pillarRep" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#4fc3f7" />
        <stop offset="100%" stopColor="#0d47a1" />
      </linearGradient>
    </defs>

    <rect x="50" y="60" width="100" height="200" rx="12" fill="url(#pillarReg)" opacity="0.85" />
    <text x="100" y="40" textAnchor="middle" fontSize="32">🏛️</text>
    <text x="100" y="160" textAnchor="middle" fill="#fff" fontSize="16" fontWeight="700">REGULAÇÃO</text>
    <text x="100" y="185" textAnchor="middle" fill="#fff" fontSize="11" opacity="0.9">LGPD · BACEN</text>
    <text x="100" y="202" textAnchor="middle" fill="#fff" fontSize="11" opacity="0.9">ANVISA · SUSEP</text>

    <rect x="200" y="90" width="100" height="170" rx="12" fill="url(#pillarBiz)" opacity="0.85" />
    <text x="250" y="70" textAnchor="middle" fontSize="32">💼</text>
    <text x="250" y="175" textAnchor="middle" fill="#fff" fontSize="16" fontWeight="700">NEGÓCIO</text>
    <text x="250" y="200" textAnchor="middle" fill="#fff" fontSize="11" opacity="0.9">Confiança</text>
    <text x="250" y="217" textAnchor="middle" fill="#fff" fontSize="11" opacity="0.9">Aprendizado</text>

    <rect x="350" y="60" width="100" height="200" rx="12" fill="url(#pillarRep)" opacity="0.85" />
    <text x="400" y="40" textAnchor="middle" fontSize="32">🌟</text>
    <text x="400" y="160" textAnchor="middle" fill="#fff" fontSize="16" fontWeight="700">REPUTAÇÃO</text>
    <text x="400" y="185" textAnchor="middle" fill="#fff" fontSize="11" opacity="0.9">Clientes</text>
    <text x="400" y="202" textAnchor="middle" fill="#fff" fontSize="11" opacity="0.9">Acionistas</text>
  </svg>
);

const EightSteps: React.FC = () => {
  const steps = [
    { icon: '🎯', label: 'Orquestração', color: '#4fc3f7' },
    { icon: '📊', label: 'DCP Sample', color: '#29b6f6' },
    { icon: '🤖', label: 'LLM Target', color: '#5c6bc0' },
    { icon: '💾', label: 'DCP Ingestão', color: '#7e57c2' },
    { icon: '📈', label: 'EDA Exploratória', color: '#ab47bc' },
    { icon: '🧹', label: 'EDA Preparação', color: '#d81b60' },
    { icon: '🧠', label: 'Knowledge', color: '#ff7043' },
    { icon: '🤖', label: 'ML Treinamento', color: '#66bb6a' },
  ];

  return (
    <svg viewBox="0 0 800 160" className="gov-illustration-wide" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="traceGlow" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#4fc3f7" stopOpacity="0.8" />
          <stop offset="100%" stopColor="#66bb6a" stopOpacity="0.8" />
        </linearGradient>
      </defs>

      <line x1="40" y1="80" x2="740" y2="80" stroke="url(#traceGlow)" strokeWidth="3" strokeDasharray="6 4" />

      {steps.map((s, i) => {
        const x = 50 + i * 100;
        return (
          <g key={i}>
            <circle cx={x} cy="80" r="32" fill={s.color} opacity="0.15" />
            <circle cx={x} cy="80" r="24" fill={s.color} opacity="0.35" />
            <circle cx={x} cy="80" r="18" fill={s.color} />
            <text x={x} y="86" textAnchor="middle" fontSize="16">{s.icon}</text>
            <text x={x} y="130" textAnchor="middle" fill="#e0e0e0" fontSize="11" fontWeight="600">{s.label}</text>
          </g>
        );
      })}

      <polygon points="760,80 740,70 740,90" fill="#ffc107" />
    </svg>
  );
};

const ThreeRecords: React.FC = () => (
  <svg viewBox="0 0 500 220" className="gov-illustration" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="recEvent" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#4fc3f7" />
        <stop offset="100%" stopColor="#1565c0" />
      </linearGradient>
      <linearGradient id="recDec" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#ab47bc" />
        <stop offset="100%" stopColor="#6a1b9a" />
      </linearGradient>
      <linearGradient id="recRes" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#66bb6a" />
        <stop offset="100%" stopColor="#2e7d32" />
      </linearGradient>
    </defs>

    <g transform="translate(40, 40)">
      <rect x="0" y="0" width="120" height="140" rx="8" fill="url(#recEvent)" opacity="0.15" stroke="#4fc3f7" strokeWidth="2" />
      <text x="60" y="40" textAnchor="middle" fontSize="32">⏱️</text>
      <text x="60" y="70" textAnchor="middle" fill="#4fc3f7" fontSize="14" fontWeight="700">EVENTO</text>
      <rect x="20" y="85" width="80" height="4" rx="2" fill="#4fc3f7" opacity="0.5" />
      <rect x="20" y="95" width="60" height="4" rx="2" fill="#4fc3f7" opacity="0.5" />
      <rect x="20" y="105" width="70" height="4" rx="2" fill="#4fc3f7" opacity="0.5" />
      <rect x="20" y="115" width="50" height="4" rx="2" fill="#4fc3f7" opacity="0.5" />
    </g>

    <g transform="translate(190, 40)">
      <rect x="0" y="0" width="120" height="140" rx="8" fill="url(#recDec)" opacity="0.15" stroke="#ab47bc" strokeWidth="2" />
      <text x="60" y="40" textAnchor="middle" fontSize="32">⚖️</text>
      <text x="60" y="70" textAnchor="middle" fill="#ab47bc" fontSize="14" fontWeight="700">DECISÃO</text>
      <rect x="20" y="85" width="80" height="4" rx="2" fill="#ab47bc" opacity="0.5" />
      <rect x="20" y="95" width="60" height="4" rx="2" fill="#ab47bc" opacity="0.5" />
      <rect x="20" y="105" width="70" height="4" rx="2" fill="#ab47bc" opacity="0.5" />
      <rect x="20" y="115" width="50" height="4" rx="2" fill="#ab47bc" opacity="0.5" />
    </g>

    <g transform="translate(340, 40)">
      <rect x="0" y="0" width="120" height="140" rx="8" fill="url(#recRes)" opacity="0.15" stroke="#66bb6a" strokeWidth="2" />
      <text x="60" y="40" textAnchor="middle" fontSize="32">📊</text>
      <text x="60" y="70" textAnchor="middle" fill="#66bb6a" fontSize="14" fontWeight="700">RESULTADO</text>
      <rect x="20" y="85" width="80" height="4" rx="2" fill="#66bb6a" opacity="0.5" />
      <rect x="20" y="95" width="60" height="4" rx="2" fill="#66bb6a" opacity="0.5" />
      <rect x="20" y="105" width="70" height="4" rx="2" fill="#66bb6a" opacity="0.5" />
      <rect x="20" y="115" width="50" height="4" rx="2" fill="#66bb6a" opacity="0.5" />
    </g>
  </svg>
);

const GovernanceFlow: React.FC = () => (
  <svg viewBox="0 0 400 400" className="gov-illustration" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="gvModel" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#4fc3f7" />
        <stop offset="100%" stopColor="#1565c0" />
      </linearGradient>
      <linearGradient id="gvEval" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#ab47bc" />
        <stop offset="100%" stopColor="#6a1b9a" />
      </linearGradient>
      <linearGradient id="gvApproved" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#66bb6a" />
        <stop offset="100%" stopColor="#2e7d32" />
      </linearGradient>
      <linearGradient id="gvRejected" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#ef5350" />
        <stop offset="100%" stopColor="#b71c1c" />
      </linearGradient>
    </defs>

    <rect x="120" y="20" width="160" height="60" rx="10" fill="url(#gvModel)" opacity="0.9" />
    <text x="200" y="50" textAnchor="middle" fill="#fff" fontSize="13" fontWeight="700">🤖 MODELO TREINADO</text>

    <polygon points="200,90 190,100 210,100" fill="#4fc3f7" />
    <line x1="200" y1="80" x2="200" y2="100" stroke="#4fc3f7" strokeWidth="2" />

    <rect x="100" y="110" width="200" height="70" rx="10" fill="url(#gvEval)" opacity="0.9" />
    <text x="200" y="140" textAnchor="middle" fill="#fff" fontSize="13" fontWeight="700">⚖️ AVALIAÇÃO AUTOMÁTICA</text>
    <text x="200" y="162" textAnchor="middle" fill="#fff" fontSize="11" opacity="0.9">Critério objetivo · Auditável</text>

    <line x1="200" y1="180" x2="200" y2="200" stroke="#ab47bc" strokeWidth="2" />
    <line x1="120" y1="200" x2="280" y2="200" stroke="#ab47bc" strokeWidth="2" />
    <line x1="120" y1="200" x2="120" y2="230" stroke="#66bb6a" strokeWidth="2" />
    <line x1="280" y1="200" x2="280" y2="230" stroke="#ef5350" strokeWidth="2" />

    <rect x="30" y="230" width="180" height="70" rx="10" fill="url(#gvApproved)" opacity="0.9" />
    <text x="120" y="258" textAnchor="middle" fill="#fff" fontSize="13" fontWeight="700">✅ APROVADO</text>
    <text x="120" y="280" textAnchor="middle" fill="#fff" fontSize="11" opacity="0.9">→ Produção</text>

    <rect x="190" y="230" width="180" height="70" rx="10" fill="url(#gvRejected)" opacity="0.9" />
    <text x="280" y="258" textAnchor="middle" fill="#fff" fontSize="13" fontWeight="700">❌ REJEITADO</text>
    <text x="280" y="280" textAnchor="middle" fill="#fff" fontSize="11" opacity="0.9">→ Descartado</text>

    <text x="200" y="340" textAnchor="middle" fontSize="48">⚖️</text>
    <text x="200" y="375" textAnchor="middle" fill="#ffc107" fontSize="12" fontWeight="600">CRITÉRIO OBJETIVO</text>
  </svg>
);

export const Governanca: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="governanca-page">
      <PublicNav />
      <div className="governanca-container">

        <section className="governanca-hero">
          <div className="governanca-hero-badge">🛡️ Governança · Auditoria · Rastreabilidade</div>
          <h1>
            Decisões auditáveis.
            <br />
            <span className="highlight">Do dado bruto à produção.</span>
          </h1>
          <AuditLayers />
          <p className="governanca-hero-sub">
            O <strong>AutoSAGE</strong> entrega <strong>rastreabilidade científica</strong>,
            <strong> auditoria verificável</strong> e <strong>governança ativa</strong> desde a fundação.
            Cada decisão é explicável, reproduzível e pronta para inspeção regulatória.
          </p>
          <div className="governanca-hero-actions">
            <button className="btn-gov-primary" onClick={() => navigate('/monitor')}>
              📡 Ver rastreabilidade
            </button>
            <button className="btn-gov-secondary" onClick={() => navigate('/scientific-dashboard')}>
              📖 Ver jornada científica
            </button>
          </div>
        </section>

        <section className="governanca-section">
          <h2 className="governanca-section-title">O que significa "auditável" em IA</h2>
          <p className="governanca-section-sub">
            A maioria das plataformas entrega resultados. Poucas entregam explicações.
            Praticamente nenhuma entrega auditoria completa.
          </p>
          <div className="triade">
            <div className="triade-item" style={{ borderTopColor: '#4fc3f7' }}>
              <span className="triade-icon">📊</span>
              <h3 style={{ color: '#4fc3f7' }}>Resultado</h3>
              <p>"O cliente X tem 82% de probabilidade de cancelar"</p>
            </div>
            <div className="triade-item" style={{ borderTopColor: '#ab47bc' }}>
              <span className="triade-icon">🔍</span>
              <h3 style={{ color: '#ab47bc' }}>Explicação</h3>
              <p>"O modelo considerou tempo de contrato, reclamações e atrasos"</p>
            </div>
            <div className="triade-item" style={{ borderTopColor: '#66bb6a' }}>
              <span className="triade-icon">📋</span>
              <h3 style={{ color: '#66bb6a' }}>Auditoria</h3>
              <p>"O modelo foi treinado com 100 mil registros em 20/09, com precisão de 75%; foi aprovado automaticamente; tem o identificador Z"</p>
            </div>
          </div>
          <div className="governanca-destaque">
            <span className="destaque-icon">🧬</span>
            <p>
              Cada decisão é vinculada a um identificador único chamado <code>trace_id</code>.
              Com ele, qualquer pessoa autorizada reconstrói a jornada completa.
            </p>
          </div>
        </section>

        <section className="governanca-section">
          <h2 className="governanca-section-title">Por que auditoria é obrigatória</h2>
          <p className="governanca-section-sub">Três forças tornam auditoria uma necessidade, não um luxo.</p>
          <ThreePillars />
          <div className="forcas-grid">
            <div className="forca-card" style={{ borderLeftColor: '#ef5350' }}>
              <h3 style={{ color: '#ef5350' }}>🏛️ Regulação</h3>
              <ul>
                <li><strong>LGPD</strong> — decisões automatizadas devem ser explicáveis</li>
                <li><strong>Banco Central</strong> — rastreabilidade em decisão de crédito</li>
                <li><strong>ANVISA / CFM</strong> — auditoria em apoio à decisão clínica</li>
                <li><strong>SUSEP</strong> — justificativa técnica em seguros</li>
              </ul>
            </div>
            <div className="forca-card" style={{ borderLeftColor: '#ffa726' }}>
              <h3 style={{ color: '#ffa726' }}>💼 Negócio</h3>
              <ul>
                <li>Modelo que erra sem explicação <strong>destrói confiança</strong></li>
                <li>Modelo que erra com explicação permite <strong>correção</strong></li>
                <li>Modelo auditável gera <strong>aprendizado institucional</strong></li>
              </ul>
            </div>
            <div className="forca-card" style={{ borderLeftColor: '#4fc3f7' }}>
              <h3 style={{ color: '#4fc3f7' }}>🌟 Reputação</h3>
              <ul>
                <li>Clientes querem saber <strong>como</strong> a decisão foi tomada</li>
                <li>Acionistas querem saber <strong>por que</strong> o modelo mudou</li>
                <li>Reguladores querem saber <strong>quem</strong> aprovou <strong>o quê</strong></li>
              </ul>
            </div>
          </div>
        </section>

        <section className="governanca-section">
          <h2 className="governanca-section-title">Os três pilares</h2>
          <p className="governanca-section-sub">Juntos, eles não existem em nenhum concorrente.</p>

          <div className="pilar-block">
            <div className="pilar-header">
              <span className="pilar-numero" style={{ background: 'linear-gradient(135deg, #4fc3f7, #1565c0)' }}>1</span>
              <h3>🧬 Rastreabilidade total</h3>
            </div>
            <p>
              Cada execução gera um <code>trace_id</code> único que conecta as <strong>oito etapas</strong>
              do processo científico. Esse identificador é o fio condutor de toda a jornada.
            </p>
            <EightSteps />
          </div>

          <div className="pilar-block">
            <div className="pilar-header">
              <span className="pilar-numero" style={{ background: 'linear-gradient(135deg, #ab47bc, #6a1b9a)' }}>2</span>
              <h3>📋 Auditoria verificável</h3>
            </div>
            <p>
              Cada decisão deixa <strong>três tipos de registro</strong>: evento, decisão e resultado.
              Disponíveis na interface, na jornada científica e em relatórios exportáveis.
            </p>
            <ThreeRecords />
          </div>

          <div className="pilar-block">
            <div className="pilar-header">
              <span className="pilar-numero" style={{ background: 'linear-gradient(135deg, #66bb6a, #2e7d32)' }}>3</span>
              <h3>⚖️ Governança ativa</h3>
            </div>
            <p>
              A plataforma <strong>não apenas registra — ela governa</strong>: aprovação automática
              de modelos com critério objetivo, rejeição abaixo do mínimo, comparação de versões
              e bloqueio de uso de modelos não aprovados.
            </p>
            <GovernanceFlow />
          </div>
        </section>

        <section className="governanca-section">
          <h2 className="governanca-section-title">Como você verifica cada item</h2>
          <p className="governanca-section-sub">
            Tela por tela, em menos de cinco minutos, você comprova cada pilar da governança.
          </p>

          <div className="verificacao-grid">
            {[
              { title: 'Acompanhamento', color: '#4fc3f7', icon: '📡', h3: '1. Rastreabilidade de uma execução', onde: 'Menu 📡 Acompanhamento', bullets: ['Lista de execuções, cada uma com seu trace_id', 'Data e hora de início', 'Status atual (em andamento / concluída / falha)', 'Duração total'], prova: '✅ Toda decisão tem origem rastreável.' },
              { title: 'Acompanhamento → execução', color: '#29b6f6', icon: '⚙️', h3: '2. Etapas executadas', onde: 'Menu 📡 Acompanhamento → clique em uma execução', bullets: ['Lista das oito etapas do processo', 'Status de cada etapa (iniciada / rodando / concluída / falhou)', 'Duração em milissegundos', 'Mensagens de erro, se houver'], prova: '✅ Processo transparente, passo a passo.' },
              { title: 'Jornada dos Dados', color: '#ab47bc', icon: '📖', h3: '3. Decisão científica documentada', onde: 'Menu 📖 Jornada dos Dados', bullets: ['Seleção de execução por trace_id', 'Linha do tempo com 5 capítulos', 'Q&A em linguagem natural', 'Conclusão científica com status final'], prova: '✅ Decisão com narrativa auditável.' },
              { title: 'Modelos', color: '#66bb6a', icon: '🤖', h3: '4. Aprovação automática com critério', onde: 'Menu 🤖 Modelos', bullets: ['Resumo: total, aprovados, rejeitados', 'Cards com APPROVED (verde) / REJECTED (vermelho)', 'Motivo da decisão documentado', 'Modelo com trace_id vinculado'], prova: '✅ Governança ativa e automática.' },
              { title: 'Comparar Modelos', color: '#ffa726', icon: '📊', h3: '5. Histórico de evolução', onde: 'Menu 📊 Comparar Modelos', bullets: ['Comparação lado a lado de versões', 'Melhoria total (variação entre versões)', 'Melhor versão e melhor estratégia', 'Evolução visual: primeiro valor → último valor'], prova: '✅ Evolução rastreável e comparável.' },
              { title: 'Análise', color: '#ef5350', icon: '🔬', h3: '6. Integridade dos dados de entrada', onde: 'Menu 🔬 Análise', bullets: ['Estatísticas gerais do dataset', 'Alertas automáticos com sugestões', 'Distribuição do objetivo', 'Tabela detalhada por coluna'], prova: '✅ Entrada documentada e verificável.' },
              { title: 'Preparação', color: '#ab47bc', icon: '🧹', h3: '7. Transformações aplicadas', onde: 'Menu 🧹 Preparação', bullets: ['Resumo da preparação', 'Alertas sobre a preparação', 'Transformações aplicadas em detalhe', 'Resultado reproduzível'], prova: '✅ Tratamento transparente e reproduzível.' },
              { title: 'Auditoria ao vivo', color: '#66bb6a', icon: '📡', h3: '8. Auditoria em tempo real', onde: 'Menu 📡 Acompanhamento → execução em andamento', bullets: ['Barra de progresso com percentual', 'Lista de etapas com status ao vivo', 'Erros registrados em tempo real', 'Contador de tempo'], prova: '✅ Auditoria durante, não só depois.' },
            ].map((card, i) => (
              <div key={i} className="verificacao-card">
                <div className="verificacao-screen" style={{ borderColor: card.color }}>
                  <span className="verificacao-screen-icon">{card.icon}</span>
                  <span className="verificacao-screen-title" style={{ color: card.color }}>{card.title}</span>
                </div>
                <h3>{card.h3}</h3>
                <p className="verificacao-onde">Menu <strong>{card.onde.replace('Menu ', '')}</strong></p>
                <ul>
                  {card.bullets.map((b, j) => <li key={j}>{b}</li>)}
                </ul>
                <p className="verificacao-prova">{card.prova}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="governanca-section">
          <h2 className="governanca-section-title">O que torna o AutoSAGE único</h2>
          <p className="governanca-section-sub">Nenhum concorrente entrega os três pilares ao mesmo tempo.</p>
          <div className="tabela-comparativo">
            <table>
              <thead>
                <tr>
                  <th>Pilar</th>
                  <th>AutoSAGE</th>
                  <th>Concorrentes</th>
                </tr>
              </thead>
              <tbody>
                <tr><td>Rastreabilidade por <code>trace_id</code></td><td className="cell-sim">✅ Nativo</td><td className="cell-nao">⚠️ Parcial ou inexistente</td></tr>
                <tr><td>Jornada científica em linguagem natural</td><td className="cell-sim">✅ Nativo</td><td className="cell-nao">❌ Inexistente</td></tr>
                <tr><td>Aprovação automática com critério objetivo</td><td className="cell-sim">✅ Nativo</td><td className="cell-nao">❌ Inexistente</td></tr>
                <tr><td>Histórico de evolução comparável</td><td className="cell-sim">✅ Nativo</td><td className="cell-nao">⚠️ Parcial</td></tr>
                <tr><td>Auditoria durante a execução</td><td className="cell-sim">✅ Nativo</td><td className="cell-nao">⚠️ Após o fato</td></tr>
                <tr><td>Governança ativa (aprovar / rejeitar)</td><td className="cell-sim">✅ Nativo</td><td className="cell-nao">❌ Inexistente</td></tr>
              </tbody>
            </table>
          </div>
        </section>

        <section className="governanca-section">
          <h2 className="governanca-section-title">O que muda para o seu negócio</h2>
          <div className="impacto-grid">
            <div className="impacto-card" style={{ borderTopColor: '#4fc3f7' }}>
              <h3 style={{ color: '#4fc3f7' }}>👨‍💻 Time de dados</h3>
              <ul>
                <li>Sem logging manual — a plataforma já registra tudo</li>
                <li>Sem dashboards de auditoria — a jornada já existe</li>
                <li>Sem justificar decisões — cada aprovação tem motivo</li>
              </ul>
            </div>
            <div className="impacto-card" style={{ borderTopColor: '#66bb6a' }}>
              <h3 style={{ color: '#66bb6a' }}>🛡️ Compliance</h3>
              <ul>
                <li>Cada decisão auditável em segundos</li>
                <li>Cada modelo com histórico completo</li>
                <li>Cada transformação documentada</li>
                <li>Pronto para inspeção regulatória</li>
              </ul>
            </div>
            <div className="impacto-card" style={{ borderTopColor: '#ab47bc' }}>
              <h3 style={{ color: '#ab47bc' }}>🏢 Diretoria</h3>
              <ul>
                <li>Confiança nos modelos em produção</li>
                <li>Rastreabilidade de decisões passadas</li>
                <li>Governança que não depende de pessoas</li>
                <li>Compliance que não vira gargalo</li>
              </ul>
            </div>
          </div>
        </section>

        <section className="governanca-cta">
          <h2>Pronto para auditar suas decisões?</h2>
          <p>Comece agora. Importe um arquivo. Veja cada etapa registrada, cada modelo aprovado, cada decisão rastreável.</p>
          <div className="governanca-cta-actions">
            <button className="btn-gov-primary" onClick={() => navigate('/register')}>
              🚀 Criar conta
            </button>
            <button className="btn-gov-secondary" onClick={() => navigate('/ciencia')}>
              🔬 Ver visão científica
            </button>
          </div>
        </section>

      </div>
    </div>
  );
};

export default Governanca;